module.exports = __webpack_public_path__ + "img/090909_9C9C9C_555555_7C7C7C-256px.1bb20141.png";